import SignatureHelper from "@utils/helpers/signature-helper";
import React, { Dispatch, SetStateAction } from "react";
import { Signature } from "@type/core/dashboard/dashboard.types";
import { TransactionType } from "@type/core/transaction/transaction.types";
import useSignatoryCardDimension from "@utils/hooks/useSignatoryCardDimension";
import { CONSEIL_EXPERT_COMPTABLES, EMAIL_FOR_SEALING } from "@utils/Constant";
import ScellementCard from "@components/core/subComponents/SignatoryCard/ScellementCard";

interface ScellementSignatoryProps {
  index: number;
  signatures: Signature[];
  transactionType: TransactionType;
  setManualPositioning: Dispatch<SetStateAction<boolean>>;
  officeId: string;
  pageNumber: number;
}

const ScellementSignatory: React.FC<ScellementSignatoryProps> = ({
  index,
  transactionType,
  signatures,
  officeId,
  setManualPositioning,
  pageNumber,
}: ScellementSignatoryProps) => {
  const { width, height } = useSignatoryCardDimension({
    rank: index,
    pageNumber,
  });

  return (
    <ScellementCard
      cardDimensionHeight={height}
      cardDimensionWidth={width}
      documentRank={1}
      email={EMAIL_FOR_SEALING}
      transactionType={transactionType}
      firstname={CONSEIL_EXPERT_COMPTABLES}
      lastname=""
      signatures={signatures}
      setManualPositioning={setManualPositioning}
      isUserInOffice={true}
      pageNumber={pageNumber}
      officeId={officeId}
      signatureIdentificator={SignatureHelper.buildSignatureIdentificator(
        index - 1,
        0,
        0,
      )}
    />
  );
};
export default ScellementSignatory;
